import React from 'react'

export const VoiceRecognition = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_4410)'>
      <path
        d='M21 3V21H3V3H21ZM13 6H11V18H13V6ZM9 9H7V15H9V9ZM17 9H15V15H17V9Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_4410'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
)
